import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { ChevronDown, ChevronRight, LogOut, Menu, LayoutDashboard } from "lucide-react";
/* --- Pages --- (kept same imports as your original file) */
import Dashboard from "../pages/dashboard/Dashboard";
import SalesOrderListPage from "../pages/SalesOrder/SalesOrderList";
import AddSalesOrderPage from "../pages/SalesOrder/AddSalesOrderPage";
import SalesOrderDetailsPage from "../pages/SalesOrder/SalesOrderDetailsPage";
import SalesOrderNewItem from "../pages/SalesOrder/SalesOrderNewItem";
import AllotSalesOrderToPerson from "../pages/SalesOrder/AllotSalesOrderToPerson";
import PendingSalesView from "../pages/SalesOrder/PendingSalesView";

import OrderSalesOrderListPage from "../pages/Sales/OrderSalesOrderList";
import OrderAddSalesOrderPage from "../pages/Sales/OrderAddSalesOrderPage";
import OrderSalesOrderDetailsPage from "../pages/Sales/OrderSalesOrderDetailsPage";
import OrderSalesOrderNewItem from "../pages/Sales/OrderSalesOrderNewItem";
import OrderAllotSalesOrderToPerson from "../pages/Sales/OrderAllotSalesOrderToPerson";
import OrderPendingSalesView from "../pages/Sales/OrderPendingSalesView";

import PurchaseOrderListRev from "../pages/PurchaseOrder/PurchaseOrderListRev";
import AddPurchaseOrderPage from "../pages/PurchaseOrder/AddPurchaseOrderPage";
import PurchaseOrderNewItem from "../pages/PurchaseOrder/PurchaseOrderNewItem";
import PurchaseOrderDetailsPage from "../pages/PurchaseOrder/PurchaseOrderDetailsPage";

import OrderListPage from "../pages/order/OrderListPage";
import AddOrderPage from "../pages/order/AddOrderPage";
import OrderDetailsPage from "../pages/order/OrderDetailsPage";
import OrderNewItem from "../pages/order/OrderNewItem";
import PaymentScreen from "../pages/order/PaymentScreen";
import OnlineOrderPage from "../pages/order/OnlineOrderPage";
import PendingView from "../pages/order/PendingView";
import AllotOrderToPerson from "../pages/order/AllotOrderToPerson";

import CustomerListPage from "../pages/customer/CustomerListPage";
import AddEditCustomerPage from "../pages/customer/AddEditCustomerPage";
import CustomerLedgerPage from "../pages/Customerledger/CustomerLedgerPage";
import PurchaseOrderListPage from "../pages/order/Purchaseorderlist";
import SupplierListPage from "../pages/suppiler/SupplierListPage";
import AddEditSupplierPage from "../pages/suppiler/AddEditSupplierPage";
import SupplierReceiptsPage from "../pages/ReceiptsPage/SupplierReceiptsPage";

import ReceiptsPage from "../pages/ReceiptsPage/ReceiptsPage";
import ExpensePage from "../pages/ReceiptsPage/ExpensePage";
import Cancelpage from "../pages/ReceiptsPage/Cancelpage";
import CancelListpage from "../pages/ReceiptsPage/CancelListpage";
import InvAdjustment from "../pages/ReceiptsPage/InvAdjustment";

import ItemMaster from "../pages/item/ItemMaster";
import ItemListPage from "../pages/item/ItemListPage";

import Bankaccount from "../pages/Bank/Bankaccount";



import OpeningBalanceList from "../pages/order/OpeningBalanceList";
import OpeningBalanceAdd from "../pages/order/OpeningBalanceAdd";
import OpeningBalanceEdit from "../pages/order/OpeningBalanceEdit";


import StockListPage from "../pages/order/StockListPage";
import AddStockPage from "../pages/order/AddStockPage";
import StockDetailsPage from "../pages/order/StockDetailsPage";
import StockNewItem from "../pages/order/StockNewItem";

import DeliveryList from "../pages/DeliveryList/Deliverylist";
import DeliveryPendingView from "../pages/DeliveryList/DeliveryPendingView";
import DeliveryAllotOrderToPerson from "../pages/DeliveryList/DeliveryAllotOrderToPerson";

import Report from "../pages/report/Report";
import DeliveryMIS from "../pages/report/DeliveryMIS";
import StockReport from "../pages/report/StockReport";
import OrdervsStock from "../pages/report/OrdervsStock";
import SalesPurchaseMis from "../pages/report/SalesPurchaseMis";
import SalesPurReport from "../pages/report/SalesPurReport";
import PartyStatement from "../pages/report/PartyStatement";
import SupplierPartyStatement from "../pages/report/SupplierPartyStatement";
import ReceiptPaymentReport from "../pages/report/ReceiptPaymentReport";
import Bankstatement from "../pages/report/Bankstatement";

import Employeemaster from "../pages/Master/Employeemaster";
import BillingModule from "../components/BillingModule/BillingModule";
import ChangePassword from "../pages/order/ChangePassword";
import Counter from "../pages/order/Counter";

/* --- API --- */
import api from "../api/api";

const AppShell = () => {
  const [view, setView] = useState("dashboard");
  const [editingContext, setEditingContext] = useState(null);
  const [open, setOpen] = useState(false); // mobile sidebar open
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [menus, setMenus] = useState([]);
  const { user, logout } = useAuth();
  const [companyInfo, setCompanyInfo] = useState({ name: "", address: "" });
  const [gdName, setGdName] = useState(sessionStorage.getItem("gdname") || "");
  const [gdid, setGdid] = useState(sessionStorage.getItem("gdid") || "");
  const [cancelList, setCancelList] = useState([]);
  const [openMenus, setOpenMenus] = useState({}); // accordion open state
  const toggleMenu = (menu) => setOpenMenus((prev) => ({ ...prev, [menu]: !prev[menu] }));

  // -------------------------
  // Fetch menus (robust parsing)
  // -------------------------
  useEffect(() => {
    const fetchMenus = async () => {
      try {
        const response = await api.RmpMenuListAPI(user?.UsrName || user);
        console.log("🔍 Full API response:", response);

        // Try several likely shapes:
        const apiRoot =
          response?.data?.RmpMenuListAPIjs ??
          response?.RmpMenuListAPIjs ??
          response?.data ??
          response;

        const menusData = apiRoot?.Table ?? [];
        console.log(" Menus extracted:", menusData);
        setMenus(menusData);
      } catch (err) {
        console.error(" Error fetching menus:", err);
        setMenus([]);
      }
    };

    fetchMenus();
  }, [user]);

  // -------------------------
  // Fetch company details (unchanged logic)
  // -------------------------
  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const usernameToSend = typeof user === "object" ? user.UsrName : user;
        const data = await api.CompanyDetails(usernameToSend);

        if (data?.Table?.length > 0) {
          const c = data.Table[0];
          setCompanyInfo({ name: c.Comname || "Company Name", address: c.Address || "" });
        }
        if (sessionStorage.getItem("gdid") && data?.Table1?.length > 0) {
          const savedGdId = sessionStorage.getItem("gdid");
          const gd = data.Table1.find((g) => g.GdId.toString() === savedGdId);
          if (gd) {
            setGdName(gd.GodownName);
            setGdid(savedGdId);
            sessionStorage.setItem("gdname", gd.GodownName);
          }
        }
      } catch (err) {
        console.error("Error loading company details", err);
        setCompanyInfo({ name: "Company Name", address: "" });
      }
    };
    fetchCompanyDetails();
  }, [user]);

  // Listen for godown changes

  useEffect(() => {
    const handleGodownChange = () => {
      setGdName(sessionStorage.getItem("gdname") || "");
      setGdid(sessionStorage.getItem("gdid") || "");
    };
    window.addEventListener("godownChanged", handleGodownChange);
    handleGodownChange();
    return () => window.removeEventListener("godownChanged", handleGodownChange);
  }, []);

  // -------------------------
  // Shortcut F2: add sales order (unchanged)
  // -------------------------
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "F2") {
        e.preventDefault();
        setView("add-salesorder");
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const groupedMenus = menus.reduce((acc, m) => {
    const type = m.MenuType || "Other";
    if (!acc[type]) acc[type] = [];
    acc[type].push(m);
    return acc;
  }, {});

  // order groups (optional) - will display in this order if present
  // const groupOrder = ["Orders", "Purchase", "Accounts", "Stock", "Report", "Other"];
  const groupOrder = Array.from(
    new Set(menus.map((m) => m.MenuType || "Other"))
  );

  // -------------------------
  // Render view (case-insensitive)
  // -------------------------
  const renderView = () => {
    const key = String(view || "").toLowerCase();

    switch (key) {
      case "dashboard":
        return <Dashboard setView={setView} setEditingContext={setEditingContext} />;

      // Sales orders & sales pages
      case "salesorders":
        return <SalesOrderListPage setView={setView} setEditingContext={setEditingContext} />;
      case "allsalesorders":
        return <SalesOrderListPage setView={setView} setEditingContext={setEditingContext} dateWise />;

      case "add-salesorder":
        return <AddSalesOrderPage setView={setView} setEditingContext={setEditingContext} />;
      case "edit-salesorder":
        return <SalesOrderDetailsPage setView={setView} context={editingContext} />;
      case "new-salesorder":
        return <SalesOrderNewItem setView={setView} context={editingContext || {}} />;
      case "pending-salesview":
      case "pending-sales-view":
        return <PendingSalesView setView={setView} />;
      case "allotsalesordertoperson":
        return <AllotSalesOrderToPerson setView={setView} />;


        case "sales":
        return <OrderSalesOrderListPage setView={setView} setEditingContext={setEditingContext} />;

          case "orderadd-salesorder":
        return <OrderAddSalesOrderPage setView={setView} setEditingContext={setEditingContext} />;
      case "orderedit-salesorder":
        return <OrderSalesOrderDetailsPage setView={setView} context={editingContext} />;
      case "ordernew-salesorder":
        return <OrderSalesOrderNewItem setView={setView} context={editingContext || {}} />;
      case "orderpending-salesview":
      case "orderpending-sales-view":
        return <OrderPendingSalesView setView={setView} />;
      case "orderallotsalesordertoperson":
        return <OrderAllotSalesOrderToPerson setView={setView} />;


      // Purchase orders
      case "purchaseorders":
        return <PurchaseOrderListRev setView={setView} setEditingContext={setEditingContext} />;
      case "add-purchaseorder":
        return <AddPurchaseOrderPage setView={setView} setEditingContext={setEditingContext} />;
      case "edit-purchaseorder":
      case "purchaseorderdetails":
        return <PurchaseOrderDetailsPage setView={setView} context={editingContext} />;
      case "new-purchaseorder":
        return <PurchaseOrderNewItem setView={setView} context={editingContext || {}} />;

      // Orders
      case "orders":
        return <OrderListPage setView={setView} setEditingContext={setEditingContext} />;
      case "add-order":
        return <AddOrderPage setView={setView} setEditingContext={setEditingContext} />;
      case "edit-order":
        return <OrderDetailsPage setView={setView} context={editingContext} />;
      case "new-order":
        return <OrderNewItem setView={setView} context={editingContext || {}} />;
      case "pending-view":
      case "pending":
        return <PendingView setView={setView} />;

      // Customers
      case "customers":
        return <CustomerListPage setView={setView} setEditingContext={setEditingContext} />;
      case "add-customer":
        return <AddEditCustomerPage setView={setView} setCustomerId={setEditingContext} />;
      case "edit-customer":
        return <AddEditCustomerPage setView={setView} customerId={editingContext} setCustomerId={setEditingContext} />;

      // Supplier
      case "supplier":
      case "suppliers":
        return <SupplierListPage setView={setView} setEditingContext={setEditingContext} />;
      case "purchase": return <PurchaseOrderListPage setView={setView} context={editingContext || {}} />;
      case "add-supplier":
      case "addsupplier":
        return <AddEditSupplierPage setView={setView} setSupplierId={setEditingContext} />;
      case "edit-supplier":
        return <AddEditSupplierPage setView={setView} supplierId={editingContext} setSupplierId={setEditingContext} />;

      // Payments / Receipts / Accounts
      case "receipt":
      case "receipts":
        return <ReceiptsPage setView={setView} />;
      case "allreceipt":
        return <ReceiptsPage setView={setView} dateWise />;
      case "supplierpayment":
      case "supplier-payment":
        return <SupplierReceiptsPage setView={setView} />;
      case "invadjustment":
      case "invoiceadjustment":
        return <InvAdjustment setView={setView} />;


      // Opening Balance Pages
      case "openingbalancelist":
      case "opening-balance":
        return <OpeningBalanceList setView={setView} setEditingContext={setEditingContext} />;

      case "openingbalanceform":
        return <OpeningBalanceAdd setView={setView} />;

      case "openingbalanceedit":
        return <OpeningBalanceEdit setView={setView} editingContext={editingContext} />;


      case "expense":
        return <ExpensePage setView={setView} />;

      case "bankaccount":
      case "bank":
        return <Bankaccount setView={setView} />;

      // Reports
      case "report":
      case "gnrl. report":
      case "gnrl. report".toLowerCase():
        return <Report />;
      case "deliverymis":
      case "delivery-mis":
        return <DeliveryMIS setView={setView} />;
      case "stockreport":
      case "stock-report":
        return <StockReport />;
      case "ordervsstock":
      case "order-vs-stock":
        return <OrdervsStock />;
      case "salespurchasemis":
        return <SalesPurchaseMis setView={setView} />;
      case "salespurreport":
      case "salespurreport":
        return <SalesPurReport setView={setView} context={editingContext} />;
      case "partystatement":
      case "party-statement":
        return <PartyStatement />;
      case "supplierpartystatement":
      case "supplier-party-statement":
        return <SupplierPartyStatement />;
      case "receipt/payment":
      case "receipt / payment":
      case "receiptpayment":
      case "receipt-payment":
        return <ReceiptPaymentReport />;
      case "bankstatement":
      case "bank-statement":
        return <Bankstatement />;

      // Stock pages
      case "stock-adjustment":
      case "stockadjustment":
        return <StockListPage setView={setView} context={editingContext || {}} />;
      case "add-stock":
        return <AddStockPage setView={setView} setEditingContext={setEditingContext} />;
      case "edit-stock":
        return <StockDetailsPage setView={setView} context={editingContext} />;
      case "new-stock":
        return <StockNewItem setView={setView} context={editingContext || {}} />;
      case "customer-ledger":
        return <CustomerLedgerPage />;

      // Item master and item list
      case "itemmaster":
      case "items":
        return <ItemMaster setView={setView} />;
      case "pricelist":
      case "price list":
        return <ItemListPage setView={setView} />;

      // Misc
      case "online-order":
      case "onlineorder":
        return <OnlineOrderPage />;
      case "getpaymentval":
        return <PaymentScreen editingContext={editingContext} setView={setView} />;
      case "cancel":
      case "cancelled documents":
      case "cancelleddocuments":
        return <Cancelpage setView={setView} cancelList={cancelList} setCancelList={setCancelList} />;
      case "cancelnew":
        return <CancelListpage setView={setView} setCancelList={setCancelList} />;
      case "employeemaster":
      case "employeemaster":
        return <Employeemaster setView={setView} />;
      case "changepassword":
        return <ChangePassword setView={setView} />;
      case "counter":
      case "counter":
        return <Counter setView={setView} />;

      // Delivery
      case "deliverylist":
        return <DeliveryList setView={setView} />;
      case "delivery-pending-view":
      case "deliverypendingview":
        return <DeliveryPendingView setView={setView} />;
      case "deliveryallotordertoperson":
      case "delivery-allot":
        return <DeliveryAllotOrderToPerson setView={setView} />;

      // default fallback — still supports API-driven menu
      default:
        // if view corresponds to an API menu name (case-insensitive), allow it (we just render Dashboard as placeholder)
        // You can expand this default area to render specialized components if needed.
        if (menus.some((m) => String(m.MenuName || "").toLowerCase() === key)) {
          // If the view is an API menu but no explicit case above, show Dashboard as a placeholder
          return <Dashboard setView={setView} setEditingContext={setEditingContext} />;
        }
        return <Dashboard setView={setView} setEditingContext={setEditingContext} />;
    }
  };

  // -------------------------
  // Helper: render ordered accordion groups
  // -------------------------
  const renderAccordionGroups = () => {
    // get keys in requested order, then remaining
    const keys = [
      ...groupOrder.filter((k) => groupedMenus[k]),
      ...Object.keys(groupedMenus).filter((k) => !groupOrder.includes(k)),
    ];

    return keys.map((type) => {
      const items = groupedMenus[type] || [];
      return (
        <div key={type} className="mb-2">
          <button
            onClick={() => toggleMenu(type)}
            className="flex w-full items-center justify-between rounded-xl px-3 py-2.5 font-semibold text-slate-700 transition hover:bg-emerald-50 hover:text-emerald-800"
          >
            <span>{type}</span>
            {openMenus[type] ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
          </button>

          {openMenus[type] && (
            <div className="mt-1 space-y-1 border-l border-emerald-100 pl-3 ml-3">
              {items.map((m) => {
                const label = m.MenuLabel || m.MenuName;
                // clicking sets view to exact MenuName (we lower-case inside renderer)
                return (
                  <button
                    key={m.Menuid ?? label}
                    onClick={() => {
                      setView(String(m.MenuName));
                      setOpen(false); // close mobile (if opened)
                    }}
                    className={`block w-full rounded-lg px-3 py-2 text-left text-slate-600 transition hover:bg-emerald-50 hover:text-emerald-800`}
                  >
                    {label}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      );
    });
  };

  // -------------------------
  // Main JSX
  // -------------------------
  return (
    <div className="flex min-h-screen bg-slate-100 text-slate-900">
      {/* Mobile hamburger */}
      <button
        className="fixed z-20 inline-flex items-center justify-center p-3 text-emerald-700 bg-white border border-emerald-100 rounded-xl shadow-lg md:hidden top-3 left-3 shadow-emerald-900/10"
        onClick={() => setOpen(!open)}
        aria-label="Open menu"
      >
        <Menu size={22} />
      </button>

      {/* Desktop menu toggle */}
      <button
        type="button"
        onClick={() => setSidebarCollapsed((value) => !value)}
        className={`fixed top-2 z-30 hidden h-9 w-9 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-700 shadow-sm transition-all duration-200 hover:bg-teal-50 hover:text-teal-700 md:flex ${sidebarCollapsed ? "left-3" : "left-[244px]"}`}
        aria-label={sidebarCollapsed ? "Open menu" : "Hide menu"}
        title={sidebarCollapsed ? "Open menu" : "Hide menu"}
      >
        <Menu size={20} />
      </button>

      {/* Sidebar Desktop */}
      <aside className={`sticky top-0 hidden h-screen flex-shrink-0 overflow-hidden border-r border-slate-200 bg-white shadow-sm transition-all duration-200 md:flex md:flex-col ${sidebarCollapsed ? "w-0 border-r-0 p-0" : "w-72 p-4 pt-3"}`}>
        <div className="mb-3 flex items-center gap-3 px-1 pr-10">
          <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
            <img
              src="/images/SrbLogo.jpeg"
              alt={companyInfo.name || "Company logo"}
              className="h-full w-full object-contain p-1"
            />
          </div>
          <div className="min-w-0">
            <div className="truncate text-lg font-semibold tracking-normal text-slate-800">{companyInfo.name || "Loading..."}</div>
            <div className="truncate text-xs text-slate-500">{companyInfo.address}</div>
          </div>
        </div>

        {gdid && (
          <div className="mb-2 flex items-center gap-2 rounded-lg border border-teal-100 bg-teal-50 px-3 py-2 text-sm text-teal-900">
            <span className="text-xs font-medium uppercase tracking-wide text-teal-600">Godown</span>
            <span className="min-w-0 truncate font-semibold">{gdName}</span>
          </div>
        )}

        <nav className="min-h-0 flex-1 space-y-2 overflow-y-auto pr-1 text-sm">
          {/* Dashboard fixed */}
          <button
            onClick={() => setView("dashboard")}
            title="Dashboard"
            className={`flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left font-semibold transition ${
              view === "dashboard"
                ? "bg-teal-600 text-white shadow-sm"
                : "text-slate-700 hover:bg-teal-50 hover:text-teal-800"
            }`}
          >
            <LayoutDashboard size={18} />
            {!sidebarCollapsed && "Dashboard"}
          </button>

          {/* Dynamic accordion groups from API */}
          {renderAccordionGroups()}

          {/* Keep your existing static accordion blocks as fallback if needed 
              (if you want to keep original blocks in addition to API menus, add them here) */}
        </nav>

        {/* Logout */}
        <div className="mt-3 border-t border-emerald-100 pt-3">
          <div className="mb-2 flex items-center gap-2 text-sm">
            <span className="text-xs font-medium uppercase tracking-wide text-slate-400">Signed in as</span>
            <span className="min-w-0 truncate font-semibold text-slate-800">{user?.UsrName}</span>
          </div>
          <button
            onClick={logout}
            className="mt-3 flex w-full items-center justify-center gap-2 rounded-lg bg-rose-500 px-3 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-rose-600"
            title="Logout"
          >
            <LogOut size={16} />
            Logout
          </button>
        </div>
      </aside>

      {/* Sidebar Mobile Popup */}
      {open && (
        <div className="fixed inset-0 z-30 bg-slate-950/30 backdrop-blur-sm md:hidden" onClick={() => setOpen(false)}>
        <div className="absolute left-3 top-16 max-h-[calc(100vh-5rem)] w-[min(20rem,calc(100vw-1.5rem))] overflow-y-auto rounded-2xl border border-emerald-100 bg-white p-4 shadow-2xl shadow-slate-900/20" onClick={(e) => e.stopPropagation()}>
          <div className="mb-4 border-b border-emerald-100 pb-3">
            <div className="flex items-center gap-2">
              <img
                src="/images/SrbLogo.jpeg"
                alt={companyInfo.name || "Company logo"}
                className="h-9 w-9 rounded-lg border border-slate-200 bg-white object-contain p-1"
              />
              <div className="text-lg font-bold text-slate-900">{companyInfo.name || "Loading..."}</div>
            </div>
            <div className="text-xs leading-snug text-slate-500">{companyInfo.address}</div>
          </div>
          {gdid && (
            <div className="mb-2 flex items-center gap-2 rounded-xl bg-emerald-50 px-3 py-2 text-sm text-emerald-900">
              <span className="text-xs font-medium uppercase tracking-wide text-emerald-600">Godown</span>
              <span className="min-w-0 truncate font-semibold">{gdName}</span>
            </div>
          )}

          <nav className="space-y-2 text-sm">
            <button
              onClick={() => { setView("dashboard"); setOpen(false); }}
              className="flex w-full items-center gap-2 rounded-xl px-3 py-2.5 text-left font-semibold text-slate-700 hover:bg-emerald-50 hover:text-emerald-800"
            >
              <LayoutDashboard size={18} />
              Dashboard
            </button>

            {/* Mobile: same dynamic groups */}
            {Object.keys(groupedMenus).length === 0 ? (
              <div className="px-2 py-1 text-sm text-gray-500">No menus available</div>
            ) : (
              Object.keys(groupedMenus).map((type) => (
                <div key={`mob-${type}`}>
                  <button
                    onClick={() => toggleMenu(`mob-${type}`)}
                    className="flex w-full items-center justify-between rounded-xl px-3 py-2 font-semibold text-left text-slate-700 hover:bg-emerald-50 hover:text-emerald-800"
                  >
                    <span>{type}</span>
                    {openMenus[`mob-${type}`] ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                  </button>

                  {openMenus[`mob-${type}`] && (
                    <div className="mt-1 ml-4 space-y-1 border-l border-emerald-100 pl-3">
                      {groupedMenus[type].map((m) => (
                        <button
                          key={`mob-${m.Menuid}`}
                          onClick={() => { setView(String(m.MenuName)); setOpen(false); }}
                          className="block w-full rounded-lg px-3 py-2 text-left text-slate-600 hover:bg-emerald-50 hover:text-emerald-800"
                        >
                          {m.MenuLabel || m.MenuName}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              ))
            )}

            {/* Logout */}
            <button
              onClick={() => { logout(); setOpen(false); window.location.reload(); }}
              className="mt-3 flex w-full items-center justify-center gap-2 rounded-xl bg-rose-500 px-3 py-2.5 text-white shadow-md shadow-rose-600/20"
            >
              <LogOut size={16} />
              Logout
            </button>
          </nav>
        </div>
        </div>
      )}

      {/* Main content */}
      <main className="min-w-0 flex-1 overflow-y-auto bg-slate-50 p-3 pt-16 md:p-4 md:pt-4">
        {renderView()}
      </main>
    </div>
  );
};

export default AppShell;


